import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  
  async buscarDadosIniciaisTelaContagens(api) {   
    let parametros = 
    {
      operacao: "buscarDadosIniciaisTelaContagens"
    }
    let retorno = {};
    
    await api.santriGET('/rest/inventario', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
  
    return retorno;  
  },
  
  async buscarInventarioEdicao(api, parametros) { 
    parametros.operacao = "buscarInventarioEdicao";
    let retorno = {};
    
    await api.santriGET('/rest/inventario', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
    return retorno;
  },
  
  async atualizarContagem(api, parametros) {  
    parametros.operacao = 'atualizarContagemInventario'
    let retorno = {};
    
    await api.santriPOST('/rest/inventario', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
    return retorno;
  },
  
  async buscarReferenciaEstoquePesquisa(api, parametros) {  
    parametros.operacao = 'buscarReferenciaEstoquePesquisa'
    let retorno = {};
    
    await api.santriGET('/rest/inventario', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })  
    return retorno;
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RInventario.js